// extracted by mini-css-extract-plugin
export default {"wrapper":"h2udZ5CF2pm2WpPuJQOAyA==","icon":"PLk44w7R7p61SOt3zlVh1A==","meta":"-mSnEKWsTXYDVQzu3dloFg=="};